import {
  HHBox,
  HHButton,
  HHButtonProps,
  HHTypography,
} from '@hinge-health/react-component-library';
import {
  buttonLabels,
  tabRoutes,
} from '../../constants/hinge-connect-constants.constant';
import { rulesRoutes } from '../constants/rules.constant';

interface RuleMessageProps {
  title: string;
  body: string;
  buttonText?: string;
  buttonProps?: HHButtonProps;
}

export const RuleMessage = ({
  title,
  body,
  buttonText,
  buttonProps,
}: RuleMessageProps): JSX.Element => (
  <HHBox textAlign="center">
    <HHTypography hhVariant="h2">{title}</HHTypography>
    <HHTypography hhVariant="body">{body}</HHTypography>
    {buttonText && (
      <HHButton
        hhVariant="variant-bypass"
        variant="contained"
        sx={{ margin: '1rem' }}
        {...buttonProps}
      >
        {buttonText}
      </HHButton>
    )}
    <HHButton
      hhVariant="variant-bypass"
      variant="contained"
      sx={{ margin: '1rem' }}
      href={`/${tabRoutes.baseRoute}/${tabRoutes.rules}/${rulesRoutes.list}`}
    >
      {buttonLabels.viewAll}
    </HHButton>
  </HHBox>
);
